module.exports = __webpack_public_path__ + "static/media/seedDividers.131fdb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/seedDividers.png
// module id = 996
// module chunks = 0